module.exports = __webpack_public_path__ + "img/jwgl-kbbd-kbbg.13acafc9.png";